import React, { useState } from "react";
import { Link } from "react-router-dom";
import { postData } from "../../api";
import "./footer.css";
import logo_centillion_ from "../../assets/images/centillion_logo/centillion_logo.png";

function Footer() {
  const currentYear = 2024;
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      setSubscribeStatus({ type: "error", message: "Please enter a valid email address." });
      return;
    }
    setLoading(true);
    try {
      const result = await postData(`${process.env.REACT_APP_BASEURL}/subscribe`, { email: email.trim() });
      const responseData = result?.data?.data || result?.data || {};
      const message = responseData?.message || result?.data?.message || "Subscribed successfully.";
      setSubscribeStatus({ type: "success", message });
      setEmail("");
    } catch (error) {
      setSubscribeStatus({ type: "error", message: "Something went wrong while subscribing." });
    } finally {
      setLoading(false);
    }
  };

  const navLinks = [
    { to: "/", label: "Home" },
    { to: "/aboutus", label: "About Us" },
    { to: "/service", label: "Services" },
    { to: "/portfolio", label: "Portfolio" },
    { to: "/career", label: "Career" },
    { to: "/blog", label: "Blog" },
    { to: "/contactus", label: "Contact Us" },
  ];

  const socialLinks = [
    {
      href: "https://www.linkedin.com/company/centillionsoftechpvtltd/mycompany/verification/",
      icon: "fa-brands fa-linkedin-in",
      cls: "linkedin",
      label: "LinkedIn",
    },
    {
      href: "https://www.facebook.com/p/CentillionSoftech-Pvt-Ltd-100071139090027/?_rdr",
      icon: "fa-brands fa-facebook-f",
      cls: "facebook",
      label: "Facebook",
    },
    {
      href: "https://www.instagram.com/centillionsoftech?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
      icon: "fa-brands fa-instagram",
      cls: "instagram",
      label: "Instagram",
    },
    {
      href: "https://wa.me/8866531035",
      icon: "fa-brands fa-whatsapp",
      cls: "whatsapp",
      label: "WhatsApp",
    },
  ];

  return (
    <footer>
      {/* Top gradient divider */}
      <div className="footer-divider" />

      {/* ── Main content ── */}
      <div className="footer_middle_area">
        <div className="container">
          <div className="row gy-4">

            {/* ── Column 1 : Brand ── */}
            <div className="col-lg-4 col-md-12">
              <img
                src={logo_centillion_}
                alt="Centillion Softech"
                className="footer-logo-img"
              />

              <p className="footer-tagline">
                Transforming ideas into powerful digital solutions. We build
                software that drives growth and delivers results.
              </p>

              {/* Social icons */}
              <ul className="social-icon-footer">
                {socialLinks.map((s) => (
                  <li key={s.cls}>
                    <a
                      href={s.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={s.label}
                      className={s.cls}
                    >
                      <i className={s.icon} />
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* ── Column 2 : Quick Links ── */}
            <div className="col-lg-4 col-md-6 footer-col-separator ps-lg-5">
              <p className="footer-section-title">Quick Links</p>
              <ul className="footer-nav-list">
                {navLinks.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>
                      <i className="fa-solid fa-chevron-right nav-arrow" />
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* ── Column 3 : Contact ── */}
            <div className="col-lg-4 col-md-6 footer-col-separator ps-lg-5">
              <p className="footer-section-title">Get In Touch</p>

              {/* Address */}
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fa-solid fa-location-dot" />
                </div>
                <div className="footer-contact-text">
                  <span>Office</span>
                  <p>
                    1103, Mulberry Heights, Kaveri Sangam Road,<br />
                    Near Shilaj Circle, Near Westside Elegance, Shilaj, Ahmedabad, Gujarat - 380059
                  </p>
                </div>
              </div>

              {/* Phone */}
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fa-solid fa-phone" />
                </div>
                <div className="footer-contact-text">
                  <span>Phone</span>
                  <a href="tel:+918866531035">+91 88665 31035</a>
                </div>
              </div>

              {/* Email */}
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <i className="fa-solid fa-envelope" />
                </div>
                <div className="footer-contact-text">
                  <span>Email</span>
                  <a href="mailto:sales@centillionsoftech.com">
                    sales@centillionsoftech.com
                  </a>
                </div>
              </div>
            </div>

          </div>{/* /row */}
        </div>{/* /container */}
      </div>{/* /footer_middle_area */}

      {/* ── Bottom bar ── */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">

            <p className="footer-copyright">
              © {currentYear} &nbsp;
              <span>Centillion Softech Pvt. Ltd.</span>
              &nbsp; All rights reserved.
            </p>

          </div>
        </div>
      </div>

    </footer>
  );
}

export default Footer;
